import React from 'react';
import Link from 'components/AppSafeLink/AppSafeLink';
import sty from './style/tabs.module.css';

interface Props {
  links: [
    {
      isActive: string;
      key: string;
      day: string;
      href: string;
    }
  ];
}

const Tabs = (props: Props) => {
  return (
    <div className="wrapper">
      <div className={`${sty.tabsContainer} container`}>
        <form className={sty.tabs}>
          <fieldset
            name="tabs-select"
            id="tabs-select"
            data-testid="tabs-select"
          >
            {props.links.map((link) => {
              return (
                <label
                  key={link.key}
                  htmlFor={link.key}
                  className={`${sty.tabsItem} ${
                    link.isActive && sty[`isActive`]
                  }`}
                >
                  <Link href={`/schedule/${link.href}`}>{link.key}</Link>
                </label>
              );
            })}
          </fieldset>
        </form>
      </div>
    </div>
  );
};

export default Tabs;
